/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActionDataStructure } from './ActionDataStructure';
import type { BeforeNotices } from './BeforeNotices';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';

export type NotifyByPagerActionStructure = {
  actionStatus?: NotifyByPagerActionStructure.actionStatus;
  description?: NaturalLanguageStringStructure;
  actionData?: Array<ActionDataStructure>;
  beforeNotices?: BeforeNotices;
  clearNotice?: boolean;
  pagerGroupRef?: string;
  pager?: string;
};

export namespace NotifyByPagerActionStructure {
  export enum actionStatus {
    OPEN = 'OPEN',
    PUBLISHED = 'PUBLISHED',
    CLOSED = 'CLOSED',
  }
}
